import React, { Component, ChangeEvent } from "react";
import Select, { SingleValue } from "react-select";
import { Input, Form, FieldText, InputContainer } from "./styles";

import importIcon from "@assets/importIcon.svg";
import importIconActive from "@assets/importIconActive.svg";
import { alertErrorStyle } from "@resources/alertErrorStyle";
import { toast } from "react-toastify";
import { csvHelper } from "@helpers/csvHelper";
import { arrayHelper } from "@helpers/array";

// Tipagem das opções do Select
interface OptionType {
  value: string;
  label: string;
}

// Tipagem das props esperadas no componente
interface UploadProps {
  setData: (type: string, data: unknown[]) => void;
  optionChanged: () => void;
  importData?: unknown[];
}

// Tipagem do state local
interface UploadState {
  csvFile: File | string;
  loading: boolean;
  selectedOption: string;
}

export default class Upload extends Component<UploadProps, UploadState> {
  fileInput: HTMLInputElement | null = null;

  state: UploadState = {
    csvFile: "",
    loading: false,
    selectedOption: "",
  };

  setCsvFile = (csvFile: File | string) => {
    this.setState({ csvFile });
  };

  importCsvFile = (csvFile: File) => {
    const reader = new FileReader();
    const { selectedOption } = this.state;
    this.setState({ loading: true });

    reader.onload = (e: ProgressEvent<FileReader>) => {
      const text = e.target?.result as string;

      const splitFile = text.split("\r\n");
      const [header, ...files] = splitFile;

      const headerSplit = header.split(";");

      const { valid, invalidFields } = csvHelper.validateHeader(headerSplit);

      if (!valid) {
        return toast(
          `A planilha selecionada não possui as colunas obrigatórias: ${arrayHelper.arrayToString(
            invalidFields,
            ", "
          )}`,
          alertErrorStyle
        );
      }

      const { array, errors } = csvHelper.processCsv(files, headerSplit);

      if (errors.length === 0) {
        this.props.setData(selectedOption, array);
        this.setState({ loading: false });
      } else {
        for (const errorMessage of errors) {
          toast(errorMessage, alertErrorStyle);
        }
      }
    };

    reader.readAsText(csvFile, "ISO-8859-1");
  };

  importCsvFileAuxBrasil = (csvFile: File) => {
    const reader = new FileReader();
    this.setState({ loading: true });

    reader.onload = (e: ProgressEvent<FileReader>) => {
      const text = e.target?.result as string;
      const splitFile = text.split("\r\n");
      const [, ...files] = splitFile;
      const array: unknown[] = [];

      for (const line of files) {
        if (line === "") break;

        const column = line.split(";");
        array.push({
          id: column[2],
          cpf: column[2],
          name: column[1],
        });
      }

      this.props.setData("auxBrasil", array);
      this.setState({ loading: false });
    };

    reader.readAsText(csvFile);
  };

  importCsvFileDeferidos = (csvFile: File) => {
    const reader = new FileReader();
    this.setState({ loading: true });

    reader.onload = (e: ProgressEvent<FileReader>) => {
      const text = e.target?.result as string;
      const splitFile = text.split("\r\n");
      const [, ...files] = splitFile;
      const array: unknown[] = [];

      for (const line of files) {
        if (line === "") break;

        const column = line.split(";");
        array.push({
          id: column[1],
          cpf: column[1],
          name: column[3],
        });
      }

      this.props.setData("deferidos", array);
      this.setState({ loading: false });
    };

    reader.readAsText(csvFile);
  };

  render() {
    const { csvFile, selectedOption } = this.state;

    const options: OptionType[] = [
      { value: "indeferidos", label: "Indeferidos Mapa" },
      { value: "indeferidosDb", label: "Indeferidos Banco de Dados" },
      { value: "deferidos", label: "Deferidos" },
      { value: "auxBrasil", label: "Auxílio Brasil" },
    ];

    return (
      <Form>
        <FieldText>Selecione o tipo de importação</FieldText>
        <Select
          id="select-import"
          options={options}
          styles={{
            container: (base) => ({ ...base, borderRadius: 40 }),
            control: (base) => ({ ...base, padding: 3, borderRadius: 40 }),
            multiValue: (base) => ({
              ...base,
              borderRadius: 40,
              backgroundColor: "#ECF2FB",
            }),
          }}
          onChange={(selectedOption: SingleValue<OptionType>) => {
            if (!selectedOption) return;

            if (csvFile) {
              if (this.fileInput) this.fileInput.value = "";
              this.setCsvFile("");
              this.props.optionChanged();
            }

            this.setState({ selectedOption: selectedOption.value });
          }}
        />
        {selectedOption ? (
          <InputContainer>
            <div>
              <img
                src={this.props.importData?.length > 0 ? importIconActive : importIcon}
                alt="import status"
              />
              <h3>
                {this.props.importData?.length > 0 ? "Arquivo selecionado" : "Escolher arquivo..."}
              </h3>
            </div>

            <Input
              type="file"
              accept=".csv"
              id="csvfile"
              ref={(ref) => (this.fileInput = ref)}
              placeholder=""
              value={""}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                const file = e.target.files?.[0];
                if (!file) return;

                this.setCsvFile(file);

                switch (selectedOption) {
                  case "indeferidos":
                  case "indeferidosDb":
                    this.importCsvFile(file);
                    break;
                  case "auxBrasil":
                    this.importCsvFileAuxBrasil(file);
                    break;
                  case "deferidos":
                    this.importCsvFileDeferidos(file);
                    break;
                }
              }}
            />
          </InputContainer>
        ) : null}
      </Form>
    );
  }
}
